import { Helmet } from 'react-helmet';
import { AnalysisWizard, Page, Panel, Panels, } from 'components_old';
import { useTranslation } from 'hooks';

export const PortfolioAnalysisPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>
          {t('common.appName')} | {t('routes.portfolioAnalysis')}
        </title>
      </Helmet>

      <Page>
        <Panels>
          <Panel
            header={<>{t('routes.portfolioAnalysis')}</>}
            body={
              <AnalysisWizard />
            }
          />
        </Panels >
      </Page >
    </>
  );
};

